// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-project--Rd3zK{padding:12px 20px;color:#798294}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"add-project": "add-project--Rd3zK"
};
export default ___CSS_LOADER_EXPORT___;
